// extracted by mini-css-extract-plugin
export default {"customerIssuePage":"CustomerIssuePage_customerIssuePage__5InNE"};